import { createMutationMixin } from '@/shared'
import { reportingService } from '@/services'

export const useAddAllowedHash = () => createMutationMixin({
  name: 'addAllowedHash',
  service: [reportingService.addComponentHash, 'cpv.addAllowedHashSuccessful'],
  onSuccess (_, input) {
    this.$router.push({ name: 'allowed-hash-list', query: { component: input.component } })
  },
})

export const useRemoveAllowedHash = () => createMutationMixin({
  name: 'removeAllowedHash',
  service: [reportingService.removeComponentHash, 'cpv.removeAllowedHashSuccessful'],
})
